import { useState, useEffect } from 'react'

export default function LoadingScreen({ onLoadingComplete }) {
    const [progress, setProgress] = useState(0)
    const [isVisible, setIsVisible] = useState(true)
    const [fadeOut, setFadeOut] = useState(false)

    useEffect(() => {
        // Simulate loading progress
        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    clearInterval(interval)
                    // Show 100% briefly, then start fade out and call onLoadingComplete
                    setTimeout(() => {
                        setFadeOut(true)
                        onLoadingComplete() // This will start the Canvas fade-in
                        // Hide component after fade animation completes
                        setTimeout(() => {
                            setIsVisible(false)
                        }, 1200) // Give more time for Canvas to render
                    }, 500)
                    return 100
                }
                return prev + Math.random() * 10 + 5 // Random increment for realistic feel
            })
        }, 150)

        return () => clearInterval(interval)
    }, [onLoadingComplete])

    if (!isVisible) return null

    return (
        <div className={`loading-screen ${fadeOut ? 'fade-out' : ''}`}>
            <div className="loading-content">
                <h1 className="welcome-title">Welcome to My Portfolio</h1>
                <p className="welcome-subtitle">Devontay Cross - Creative Developer</p>
                
                <div className="loading-bar-container">
                    <div className="loading-bar">
                        <div 
                            className="loading-bar-fill" 
                            style={{ width: `${progress}%` }}
                        />
                    </div>
                    <span className="loading-percentage">{Math.round(progress)}%</span>
                </div>
                
                <p className="loading-text">Loading 3D experience...</p>
            </div>
        </div>
    )
}